import { useMemo, Fragment } from 'react';
import type { Validation } from '../Table';
import { Error } from './Error';
import { RowsError } from './RowError';

type Props = {
  validation: Validation;
  onDismiss: () => void;
  onRangeClick: (row: number) => void;
};

export const ValidationError = ({
  validation,
  onDismiss,
  onRangeClick,
}: Props) => {
  const { error, errorRowRanges } = validation;

  const normalisedRanges = useMemo(
    () =>
      errorRowRanges.reduce<[number, string][]>((a, b) => {
        const first = b[0];
        const last = b[b.length - 1];
        const value = first === last ? `${first}` : `${first}-${last}`;
        return [...a, [b[0], value]];
      }, []),
    [errorRowRanges]
  );

  return (
    <Error onDismiss={onDismiss}>
      {error !== null ? (
        <RowsError errorType="input">
          {error}
          {` `}
          {normalisedRanges.map((n, i) => (
            <Fragment key={`row-error-${i}`}>
              {i === 0 ? `` : `, `}
              <button onClick={() => onRangeClick(n[0])}>
                <span className="underline">{n[1]}</span>
              </button>
            </Fragment>
          ))}
        </RowsError>
      ) : (
        'Unknown error'
      )}
    </Error>
  );
};
